import { useOutletContext } from 'react-router';
import { DnsEditor, type Domain } from '@/domains/domains-registry';

/**
 * Customer-side DNS tab on the domain detail page. G1 (P1, cPanel-backed).
 * Wraps the shared DnsEditor with `mode='customer'` — apex NS becomes
 * read-only, last-MX delete requires confirmation, etc.
 *
 * The editor itself shows a banner when DNS isn't hosted by SightHost
 * (FR-13/14) and disables edit actions in that case.
 */
export default function DomainDnsTab() {
  const domain = useOutletContext<Domain>();
  return <DnsEditor domain={domain.name} mode="customer" />;
}
